export const ROUTE_PATH = {
  LOGIN: '/',
  DASHBOARD: '/dashboard',
  DASHBOARD_OVERVIEW: '/dashboard/overview',
  DASHBOARD_ENGAGEMENT: '/dashboard/engagement',
  DASHBOARD_TOPICS: '/dashboard/topics',
  DASHBOARD_PEERS: '/dashboard/peers',
  DASHBOARD_NAVIGATION: '/dashboard/navigation',
  LISTENERS: '/listeners',
  SEARCH_QUERIES: '/search-queries',
  LINKS: '/links',
  CONTENT_RECOMMENDATIONS: '/content-recommendations',
  PLUS_CARE: '/+care',
  PLUS_CARE_CONTENT: '/+care/content',
  PEERS: '/peers',
  SCHEDULE_OVERVIEW: '/peers/schedule-overview',
  SCHEDULE_HISTORY: '/peers/schedule-history',
  PEERSONA_CHAT_LOGS: '/peers/peersona-chat-logs',
  REVIEW: '/review',
  CHECKINS: '/checkins',
  REQUESTS: '/requests',
  DEMOGRAPHICS: '/review',
  PROJECT_MANAGEMENT: '/project-management',
  SAFETY: '/safety',
  LISTENERS_PROFILE: '/peers/listeners/profile',
  LISTENERS_CONTENT_REVIEW: '/peers/listeners/content-review',
  LISTENERS_ENGAGEMENT: '/peers/listeners/engagement',
  LISTENERS_CONNECTION: '/peers/listeners/connection',
  LISTENERS_AVAILABLE: '/peers/listeners/availabilty',
  LISTENER_AUDIO_REVIEW: '/peers/listeners/audio',
  LISTENER_VIDEO_REVIEW: '/peers/listeners/video',
  LISTENER_PAYOUT: '/peers/listeners/payout',
  LISTENERS_LOG: '/peers/listeners/log',
  LISTENERS_ON_CALL: '/peers/listeners/oncall',

  PEERS_PROFILE: '/peers/profile',
  PEERS_CONTENT_REVIEW: '/peers/content-review',
  PEERS_ENGAGEMENT: '/peers/engagement',
  PEERS_CONNECTION: '/peers/connection',
  PEER_AUDIO_REVIEW: '/peers/audio',
  PEER_VIDEO_REVIEW: '/peers/video',
  PEER_PAYOUT: '/peers/payout',
  PEER_PEERSONA: '/peers/peersona',
  PEER_LOG: '/peers/log',

  MEMBERS: '/members',
  MEMBERS_PROFILE: '/members/profile',
  MEMBERS_CONNECTIONS: '/members/connection',
  MEMBERS_LOG: '/members/log',
  SETTINGS: '/settings',
  STORIES: '/stories',
  TOPICS: '/topics',
  GROUPS: '/groups',
  GROUPS_PACKAGES: '/groups/packages',
  GROUPS_CONFIGURE: '/groups/configure',
  GROUPS_ELIGIBILITY: '/groups/eligibility',
  GROUPS_RESOURCES: '/groups/resources',
  GROUPS_ADMINS: '/groups/admins',
  GROUPS_SSO_CONFIGURATION: '/groups/sso-configuration',
  GROUPS_PEERSONA_CONFIGURATION: '/groups/peersona-configuration',
  REPORTING: '/groups/reporting',
  ELIGIBILITY_TOOL: '/groups/eligibility-tool',
  // THEME_CONFIGURATION: '/groups/theme-configuration',
  DEFAULT_CONTENT: '/groups/default-content',
  TEMPLATES_COMMS: '/templates/comms',
  NOTIFY_MESSAGE: '/notify-message',
  ONBOARDING: '/onboarding',
  REQUESTNEWINVITE: '/request-new-invite',
  INVITEREVOKE: '/invite-revoked',
  MEMBERSTOC: '/text-blocks/members',
  CLIENTADMINTOC: '/text-blocks/client-admin',
  LISTENRFAQTOC: '/text-blocks/listener-faq',
  VERSIONED_AGREEMENTS: '/text-blocks/versioned-records',
  AI_PROMPTS: '/text-blocks/ai-prompts',
  FI_CONCIERGE: '/text-blocks/fi-concierge',
  PEERSONA_CRISIS_DEFAULTS: '/text-blocks/peersona-crisis-defaults',
  INVITATION_COMPLETED: '/onboarding-completed',
  TIERS: '/tiers',
  TIER_DETAILS: '/tiers/tier-details',
  TAGS: '/tags',
  TAGS_DETAILS: '/tags/tags-details',
  TAG_GROUPS: '/tags/tag-groups',
  TAG_GROUPS_DETAILS: '/tags/tag-groups-details',
  RESOURCES: '/resources',
  CONTENT_LIBRARY: '/content-library',
  AUDIO_SAMPLES: '/content-library/audio-samples',
  RESOURCES_DETAILS: '/resources-details',
  AUDIO_REVIEW: '/listener-reviews/audio',
  VIDEO_REVIEW: '/listener-reviews/video',
  PROFILE: '/listener-reviews/profiles',
  DISPLAY_NAME: '/listener-reviews/display-name',
  ABOUT_ME: '/listener-reviews/about-me',
  BACKGROUND_TAGS: '/listener-reviews/background-tags',
  FILES: '/files',
  CALLS: '/calls',
  SYSTEM_USERS: '/users',
  CALLS_REPORT: '/reports/calls',
  ENGAGEMENTS_REPORT: '/reports/engagements',
  CLIENT_ENGAGEMENTS_REPORT: '/reports/client-engagements',
  TAMU_REPORT: '/reports/tamu-report',
  FEATURE_FLAGS: '/feature-flags',
  PIPELINES: '/pipelines',
  PERSONAS: '/personas',
  PERSONAS_SHARED_RULES: '/personas/shared-rules',
  PERSONA_OVERVIEW: '/personas/:personaId/overview',
  PERSONA_CLIENTS: '/personas/:personaId/clients',
  PERSONA_RULES: '/personas/:personaId/rules',
  PERSONA_EVALS: '/personas/:personaId/evals',
  PERSONA_PROMPTS: '/personas/:personaId/prompts',
  PERSONA_CHAT: '/personas/:personaId/chat',

  //clients
  SNAPSHOT: '/snapshot',
  ENAGEMENT: '/engagement',
  ELIGIBILTY: '/eligibility',
  GROUPMANAGER: '/group-manager',
  MEMBER_RESOURCES: '/member-resources',
  MARKETING_LIBRARY: '/marketing-library',
  USER_MANAGEMENT: '/user-safety/user-management',
  BLACKLIST: '/user-safety/blacklist',
  BLOCKED: '/user-safety/blocked',
};
